import type { RouteObject } from 'react-router-dom';
import { lazyElement } from '../routing/lazyRoute';

const inmateAccountPaymentRoutes: RouteObject[] = [
  {
    path: '/inmate-account-payment',
    element: lazyElement(() => import('./Search')),
    handle: {
      documentTitle: 'Account Payments',
      crumb: () => ({ label: 'Account Payments', to: '/inmate-account-payment' })
    },
  },
];

export default inmateAccountPaymentRoutes;
